module.exports = __webpack_public_path__ + "assets/img/d07e77ef818606a20e80f37a418d0e79.svg";